<script setup lang="ts">

import { useGameStore } from '@/stores/gameStore.ts'
import { computed } from 'vue'
import { useAssetStore } from '@/stores/assetStore.ts'
import ModalTrigger from '@/components/Interface/Modal/ModalTrigger.vue'
import Eta from '@/models/eta.ts'
import SingleMulti from '@/components/Objects/SingleMulti.vue'
import StyledImage from '@/components/Elements/Images/StyledImage.vue'
import { CDN } from '@/models/cdn.ts'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import SimpleProgressBar from '@/components/Elements/ProgressBar/SimpleProgressBar.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores / models
 */
const gameStore = useGameStore()
const assetStore = useAssetStore()

/**
 * Computed
 */
const tech = computed(() => {
  return assetStore.findTechById(gameStore.player!.currentTechId)!
})

const isPrototype = computed(() => {
  return gameStore.playerPrototypes.has(gameStore.player!.currentTechId)
})

const effectiveCost = computed(() => {
  if (isPrototype.value && gameStore.player?.effectiveAllianceResearchCostMultiplier) {
    return Math.ceil(tech.value.cost * gameStore.player.effectiveAllianceResearchCostMultiplier)
  }
  return tech.value.cost
})

const techPercentage = computed(() => {
  if(!tech.value) {
    return 0;
  }
  const percentage = Math.floor((gameStore.player!.sciencePoints / effectiveCost.value)*100);
  if (percentage > 100) {
    return 100;
  }
  return percentage;
})

const eta = computed(() => {
  const eta = new Eta();
  const calculatedEta = eta.techETA(effectiveCost.value)
  return calculatedEta<0 ? 0 : calculatedEta;
})

</script>

<template>
  <StandardCard v-if="tech?.id" :title="t('research.currentlyResearching')" bottom-padding="2">
    <ModalTrigger type="tech" :data="{'techId': tech.id}">
      <div class="hidden sm:flex justify-center">
        <StyledImage :src="CDN.technology(256,tech.code)" size="lg" />
      </div>
      <div class="text-center text-metal-300 p-2"> {{ t(`research.techs.${tech.code}.name`) }}</div>
      <SimpleProgressBar color="blue" :percentage="techPercentage" :subtext="`${gameStore.player!.sciencePoints} / ${effectiveCost}`"/>
      <div class="text-center text-metal-300 p-2">
        {{ t('research.eta') }} : {{ eta }} <SingleMulti :value="eta" :single="t('research.week')" :multi="t('research.weeks')"/>
      </div>
    </ModalTrigger>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>